import React, { useEffect, useState }                                            from "react"
import { Button, Dropdown, Form, Icon, Input, Label, Message, Modal, Progress, Table, Container, Checkbox, Rating } from "semantic-ui-react";
import useQuery                                                                  from "../../../../useQuery";
import { useHistory, Link }                                                                  from "react-router-dom";
import Price, { defaultCurrencySymbol, formatPrice }                             from "../../../../components/Price/Price";
import shop                                                                      from "shop/shop"
import { observer }                                                              from "mobx-react";
import config                                                                    from "config"
import CreateCostCentreModal                                                     from "../../../../components/CostCentres/CostCentresEditForm.js"


const timeSpanTypes = {
  TS_CART: 0,
  TS_DAILY: 1,
  TS_WEEKLY: 2,
  TS_MONTHLY: 3,
  TS_QUARTER: 4,
  TS_YEAR: 5,
  TS_FIXED: 6,
  TS_FOREVER: 7,
}

const timeSpanNames = {
  0: "Warenkorb",
  1: "Tag",
  2: "Woche",
  3: "Monat",
  4: "Quartal",
  5: "Jahr"
}

const maxRepeatOptions = [
  {key: "1", text: "Wöchentlich", value: 2},
  {key: "2", text: "Monatlich", value: 3},
  {key: "3", text: "Quartalsweise", value: 4},
  {key: "4", text: "Jährlich", value: 5}
]

const DEFAULT_MAX = 100;
const DEFAULT_TIMESPAN = timeSpanTypes.TS_CART;

export default function BudgetManager( { backLink = "/account/budgets", costCentres = [], hideActivate = true, customerId } ) {
  const query = useQuery()
  const [loading, setLoading] = useState()
  const [showNewRule, setShowNewRule] = useState( false )
  const [searchValue, setSearchValue] = useState( false )
  const [searchLimit, setSearchLimit] = useState( 10 )
  const [error, setError] = useState( false)
  const { budget, showedit, showdelete } = query
  const activeCostCenter = costCentres.find( c => c.costid === budget )
  const [form, setForm] = useState( {
                                      maxValue: DEFAULT_MAX,
                                      timeSpan: DEFAULT_TIMESPAN,
                                      takeOver: false,
                                      takeMax: 0,
                                    } )
  const history = useHistory();
  const append = ( data ) => {
    setForm( { ...form, ...data } )
  }

  const [rules, setRules] = useState( [] )

  const isManager = shop.session.hasRole( "costManager" )

  useEffect( () => {
    if ( !activeCostCenter ) {
      setRules( [] )
      return
    }
    setRules( activeCostCenter.rules )
  }, [activeCostCenter] )

  // create filtered search results with limit
  const filteredCostCentres = (searchValue ? costCentres.filter((e) => { return (e.name && e.name.toLowerCase().includes(searchValue)); }) : costCentres).slice(0,searchLimit);

  const removeRule = async ( rule ) => {
    if ( !activeCostCenter ) return null
    if ( loading ) return null
    setLoading( true )
    const newRules = rules.filter( r => r !== rule )
    let response = await shop.fetch( `/shop/rest/costcentre/budgets?costcentre=${activeCostCenter.map_id}`, {
      method: "POST",
      body: JSON.stringify( [...newRules] )
    } )
    console.log( "DEL RULE", response )
    setRules( response )
    setLoading( false )
    return response
  }

  async function deleteCostCentre() {
    if (!activeCostCenter ) return null;
    if (loading) return null;
    setLoading(true)

    console.log('BACK LINK',backLink);

    let response = await shop.fetch(`/shop/rest/costcentre/data/${activeCostCenter.map_id}`, {
      method: 'DELETE'
    })

    await shop.session.prepare()

    setLoading(false)

    history.push(backLink);

    return response;
  }

  async function postBudget() {
    if ( !activeCostCenter ) return null
    if ( loading ) return null
    setLoading( true )
    const timeSpan = form.timeSpan || DEFAULT_TIMESPAN
    const maxValue = form.maxValue || DEFAULT_MAX
    const takeOver = !!form.takeOver;
    const takeMax  = form.takeMax || 0;

    if (takeOver && takeMax > 0 && takeMax <= timeSpan) {
        setError("Zeitraum für Übernahme muss größer als der Budgetzeitraum sein.");
        setLoading(false);
        return;
    }

    let response = await shop.fetch( `/shop/rest/costcentre/budgets?costcentre=${activeCostCenter.map_id}`, {
      method: "POST",
      body: JSON.stringify( [...rules, { "name": "Budget", "message": "budget.BUDGET_DEFAULT_REACHED", "costcentre": `${activeCostCenter.map_id}`, "maxValue": maxValue, "expression": "", "timeSpan": timeSpan,"takeOver": takeOver, "takeMax": takeMax }] )
    } )

    setRules( response )

    setForm( {
               maxValue: DEFAULT_MAX,
               timeSpan: DEFAULT_TIMESPAN,
               takeOver: false,
               takeMax: 0
             } )
    setShowNewRule( false )
    setLoading( false )
    setError( false )

    return response
  }

  return <div className="BudgetManager">
    {(showedit == 'true') && <CreateCostCentreModal
      customerId={customerId}
      costcentre={activeCostCenter ? activeCostCenter : false}
      backLink={backLink}>
      </CreateCostCentreModal>}

    {(showdelete == 'true' && activeCostCenter) &&
      <Modal open={!!activeCostCenter}>
        <Modal.Header>
          <div className="b">{activeCostCenter.name}</div>
        </Modal.Header>
        <Modal.Content>
          <strong>{ translate( "Möchten Sie diese Kostenstelle wirklich löschen?") }</strong>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={ (e) => { deleteCostCentre(); } } basic negative>OK</Button>
          <Button as={Link} to={backLink}>Abbrechen</Button>
        </Modal.Actions>
      </Modal>
    }

    {(showedit !== 'true' && showdelete !== 'true' && activeCostCenter) && <Modal open={!!activeCostCenter}>
      <Modal.Header>
        <div className="flex flex-row items-center">
          <div>
            <div className="b">{activeCostCenter.name}</div>
            <div className="black-70 fw4 f6">{translate( "Budget verwalten" )}</div>
          </div>
          <div className="ml-auto">
            <Button basic circular icon={"close"} as={Link} to={backLink}/>
          </div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <h3>{translate( "Regeln" )}</h3>
        {rules.length === 0 && <Message>
          {translate( "budget.NO_RULES_DEFINED" )}
        </Message>}

        <Table>
          {rules.map( rule => {
            return <Table.Row key={rule.map_id}>
              <Table.Cell>
                <Price>{rule.maxValue}</Price>
              </Table.Cell>
              <Table.Cell> {translate( "pro " + timeSpanNames[ rule.timeSpan ] )}</Table.Cell>
              <Table.Cell>
              <div className="f7 black-70">{translate("Restbudget übernehmen")}</div>
              { rule.takeOver && (<div><Icon name="toggle on"/><div className="black-70 f6">{ timeSpanNames[rule.takeMax] }</div></div>) }
              { !rule.takeOver && (<Icon name="toggle-off"/>)}
              <span>{ rule.takeOver }</span>
              </Table.Cell>
              <Table.Cell textAlign="right">
                <Button icon={"times"} onClick={() => {
                  removeRule( rule )
                }}/>
              </Table.Cell>
            </Table.Row>
          } )}

          {!showNewRule && <Table.Row>
            <Table.Cell colSpan={3}>
              <div className="flex flex-row items-center">
                <Button onClick={() => {
                  setShowNewRule( true )
                }} icon={"plus"} primary/>
                <div className="pl2 black-70 f6">
                  {translate( "Budgetregel hinzufügen" )}
                </div>
              </div>
            </Table.Cell>
          </Table.Row>}

          {showNewRule && <Table.Row>
            <Table.Cell>
              <div className="f7 black-70">{translate("max. Budget")} ({defaultCurrencySymbol})</div>
              <Input
                defaultValue={DEFAULT_MAX}
                type="number" placeholder={translate("Budget")} onChange={( e ) => {
                const maxValue = e.currentTarget.value
                append( { maxValue } )
              }}/>
              <br/>
            </Table.Cell>

            <Table.Cell>
              <div className="f7 black-70">pro</div>
              <Dropdown
                selection
                defaultValue={DEFAULT_TIMESPAN}
                onChange={( e, x ) => {
                  console.log( e, x )
                  append( { timeSpan: x.value } )
                }}
                options={[{
                  value: timeSpanTypes.TS_CART, text: translate( "Warenkorb" ), key: "Warenkorb"
                }, {
                  value: timeSpanTypes.TS_WEEKLY, text: translate( "Woche" ), key: "Woche"
                }, {
                  value: timeSpanTypes.TS_MONTHLY, text: translate( "Monat" ), key: "Monat"
                }, {
                  value: timeSpanTypes.TS_QUARTER, text: translate( "Quartal" ), key: "Quartal"
                }, {
                  value: timeSpanTypes.TS_YEAR, text: translate( "Jahr" ), key: "Jahr"
                },]}/>
            </Table.Cell>

            <Table.Cell>
              <Checkbox label={translate("Restbudget übernehmen")} onChange={(e,v) => { append( { takeOver: v.checked }); }}/>
              <br/>
              <Dropdown
                placeholder="Max. Zeitraum"
                fluid
                selection
                onChange={(e , x) => {
                  append({ takeMax: x.value })
                }}
                options={maxRepeatOptions}
              />
            </Table.Cell>

            <Table.Cell textAlign={"right"}>
              <div className="f7 black-70">{translate( "Regel speichern" )}</div>
              <Button
                style={{ marginRight: 0 }}
                loading={loading}
                size={"small"} primary onClick={() => {
                postBudget()
              }}>{translate( "speichern" )}</Button>
            </Table.Cell>
          </Table.Row>}

        </Table>
        { error && (<Message negative>
          { translate(error) }
        </Message>)}
      </Modal.Content>
      <Modal.Actions>
        <Button as={Link} to={backLink}>OK</Button>
      </Modal.Actions>
    </Modal>}

    {costCentres.length === 0 && <div>
      <div>{translate( "budget.NO_COST_CENTRES" )}</div>
    </div>}

    <Container className="mv2">
        <Input
          onChange={(e) => { setSearchValue(e.currentTarget.value.toLowerCase()); }}
          icon="search"
          placeholder={ translate("Suche") + '...'} />
    </Container>

    <div className="ui cards">
      {filteredCostCentres.map( centre => {
        return <CostCentreCard key={centre.costid} centre={centre} hideActivate={hideActivate}/>
      } )}
    </div>
    {(config.costcentre_editable) && <Container className="mv2">
      {(costCentres.length > searchLimit) && <Button onClick={(e) => { setSearchLimit(searchLimit + 10);}} primary>{ translate( "Mehr" )}</Button>}
      {isManager && (<Button color="green" as={Link} to={`?showedit=true`} basic>{translate( "Neu" )}</Button>)}
    </Container>}

  </div>
}

const CostCentreCard = observer( ( { centre, hideActivate = false } ) => {
  const session = shop.session
  const active = centre.costid === shop.session.activeCostCentreId
  const total = centre.rules[ 0 ] && centre.rules[ 0 ].maxValue
  const value = centre.rules[ 0 ] && centre.rules[ 0 ].snapshot
  const isManager = shop.session.hasRole( "costManager" )
  let color = (value / total) <= 0.8 ? "green" : "yellow"
  return <div key={centre.costid} className="ui card">
    <div className="content">
      <div className="flex flex-row items-center justify-between pb2">
        <div className={"f5 b"}>{centre.name}</div>
        {active && <Label color={"blue"}>{translate( "costCentre.active" )}</Label>}
        {config.costcentre_editable && isManager && <Button size="tiny" basic negative as={Link} to={`?budget=${centre.costid}&showdelete=true`}>
            <Icon name="trash"/>
          </Button>}
      </div>

      <div className="pb3">
        {centre.rules.map( rule => {
          return <div key={rule.id} className="f6 black-80">{translate( timeSpanNames[ rule.timeSpan ] )}, <Price>{rule.maxValue}</Price></div>
        } )}
      </div>

      {config.costcentre_editable && <Button size="tiny" as={Link} to={`?budget=${centre.costid}&showedit=true`} basic>{translate("costCentre.edit")}</Button>}
      {isManager && <Button size="tiny" basic as={Link} to={`?budget=${centre.costid}`} className="f6">{translate( "costCentre.manage" )}</Button>}
      {!hideActivate && <div><a onClick={() => {
        session.setCostCentre( centre.costid )
      }} className="f6"><Icon name={"chevron right"}/> {translate( "costCentre.activate" )}</a></div>}

    </div>

    <Progress color={color} attached={"bottom"} size={"small"} total={total} value={value}/>
  </div>
} )



// WEBPACK FOOTER //
// ./src/theme/oehme/components/Budget/BudgetManager.js